import type {
  SbWatermarkProps,
  WatermarkBadge,
  WatermarkLogoAlign,
  WatermarkVariant,
} from "./watermark.types";

export const DEFAULT_WATERMARK_PROPS: Omit<SbWatermarkProps, "seed"> = {
  variant: "brand",
  badge: "ghost",
  logoAlign: "end",
  label: "Powered by",
};

/* ------------------------------------------------------------ */

const VARIANTS_REC: Record<WatermarkVariant, WatermarkVariant> = {
  brand: "brand",
  theme: "theme",
  muted: "muted",
};

export const WATERMARK_VARIANTS: WatermarkVariant[] =
  Object.values(VARIANTS_REC);

/* ---------------------------------------- */

const BADGES_REC: Record<WatermarkBadge, WatermarkBadge> = {
  default: "default",
  secondary: "secondary",
  outline: "outline",
  ghost: "ghost",
};

export const WATERMARK_BADGES: WatermarkBadge[] = Object.values(BADGES_REC);

/* ---------------------------------------- */

const LOGO_ALIGNS_REC: Record<WatermarkLogoAlign, WatermarkLogoAlign> = {
  start: "start",
  end: "end",
};

export const WATERMARK_LOGO_ALIGNS: WatermarkLogoAlign[] =
  Object.values(LOGO_ALIGNS_REC);
